<script lang="ts">
  import { fade } from "svelte/transition";
  import { loading } from "./loading";
  import { afterUpdate } from "svelte";
  
  let timer:number;

  $: if ($loading.status === "NAVIGATING") {
    timer = setTimeout(() => {
      if ($loading.status === "NAVIGATING") {
        $loading.status = "LOADING";
        bodyScroll.prevent();
      }
    }, 1000);
  }
  $: {
    $loading;
    afterUpdate(() => {
      if ($loading.status === "IDLE") {
        bodyScroll.allow();
        clearTimeout(timer);
      }
    });
  }

  // @ts-ignore
  const bodyScroll = {
    prevent() {
      // @ts-ignore
      document.querySelector("body").style.overflow = "hidden";
    },
    allow() {
      // @ts-ignore
      document.querySelector("body").style.overflow = null;
    },
  };
</script>

<div class="inactive" class:active={$loading.status === "LOADING"}>
  <div class="loading" transition:fade>
    <div class="images">
      <div class="image">
        <img src="/images/global/bottle.svg" alt="bottle gelish" />
      </div>
      <div class="image">
        <img src="/images/global/bottle.svg" alt="bottle gelish" />
      </div>
      <div class="image">
        <img src="/images/global/bottle.svg" alt="bottle gelish" />
      </div>
      <div class="image">
        <img src="/images/global/bottle.svg" alt="bottle gelish" />
      </div>
      <div class="image">
        <img src="/images/global/bottle.svg" alt="bottle gelish" />
      </div>
    </div>
    <h3>Loading</h3>
    <p>Swatching the right colors for you</p>
  </div>
</div>

<style>
  * {
    pointer-events: none;
  }
  .inactive {
    position: fixed;
    width: 100svw;
    height: 100svh;
    background-color: #fdfdfd;
    z-index: 999999;
    top: 0;
    left: 0;
    opacity: 0;
    transition: all 0.5s ease;
  }
  .active {
    opacity: 1;
    pointer-events: all !important;
  }
  .loading {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .images {
    display: flex;
    align-items: center;
    gap: 20px;
  }
  .image {
    width: 90px;
  }
  .image img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center;
  }
  .loading h3 {
    margin-top: 65px;
    font-size: 3.6em;
    font-family: "gotham-bold";
    color: #1f2525;
    line-height: 1.5;
  }
  .loading p {
    font-weight: 400;
    font-size: 2em;
    letter-spacing: 1px;
    color: #1f2525;
    line-height: 1.2;
  }
  .images .image {
    animation: loading 2s infinite ease-in-out;
  }
  .images .image:nth-child(2) {
    animation-delay: 0.3s;
  }
  .images .image:nth-child(3) {
    animation-delay: 0.6s;
  }
  .images .image:nth-child(4) {
    animation-delay: 1.2s;
  }
  .images .image:nth-child(5) {
    animation-delay: 1.8s;
  }

  @keyframes loading {
    0%,
    100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(20%);
    }
  }

  @media (max-width: 767px) {
    .loading {
      max-width: 90svw;
      margin: 0 auto;
    }
    .image {
      width: 50px;
    }
    .loading p {
      text-align: center;
    }
  }
</style>
